export default __webpack_public_path__ + "static/media/right_bottom_image_mobile.4c776da5.png";